import axios from 'axios';

import { API_BASE_URL } from 'utils/constants';

export const handleFetchCSChart = async (startDate, endDate) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/eachRate/each',
    params: {
      start: startDate,
      end: endDate,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchRatesAvrage = async (startDate, endDate) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/rate',
    params: {
      start: startDate,
      end: endDate,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const hadnleExportRatesAverage = async (startDate, endDate) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/rate/export',
    params: {
      start: startDate,
      end: endDate,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchRatesCount = async (startDate, endDate) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/rate/count',
    params: {
      start: startDate,
      end: endDate,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const hadnleExportRatesCount = async (startDate, endDate) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/rate/count/export',
    params: {
      start: startDate,
      end: endDate,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleFetchCustomersByRate = async (startDate, endDate, type) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/rate/emotions',
    params: {
      start: startDate,
      end: endDate,
      type,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleExportCustomersByRate = async (startDate, endDate, type) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/agent/rate/emotions/export',
    params: {
      start: startDate,
      end: endDate,
      type,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

/**
 * fetches platforms statistics
 *
 * @typedef {{
 *  Chrome: number,
 *  Firefox: number,
 *  Opera: number,
 *  Safari: number,
 * }} BrowsersStats - browsers used by users stats. if one browser is not sent. it's value is 0.
 *
 * @typedef {{
 *  Windows: number,
 *  Macintosh: number,
 *  Android: number,
 *  Linux: number,
 *  mac: number
 * }} OsStats - operating systems used by users stats. if one is missing it should get considered as 0.
 *
 * @typedef {{
 *  allCount: number,
 *  desktopCount: number,
 *  mobileCount: number
 * }} Platforms - platforms stats
 *
 * @typedef {{
 *  lastDayPlatformsCount: number,
 *  lastHourPlatformsCount: number,
 *  lastMonthPlatformsCount: number
 * }} TimePeriodStats
 *
 * @param {{
 * start: string,
 * end: string,
 * channelId: string
 * }} param0
 *
 * @returns {{
 *    browsersStats: BrowsersStats,
 *    osStats: OsStats,
 *    platformsStats: Platforms,
 *    timePeriodStats: TimePeriodStats
 * }}
 */
export const handleFetchPlatformsStats = async ({ start, end, channelId }) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/channel/platforms',
    params: {
      start,
      end,
      channelId,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};

//TODO: add jsdoc annotation

/**
 * fetches users statistics
 *
 * @typedef {{
 *  day: string,
 *  count: number
 * }} CountByDay
 *
 * @typedef {{
 *  hour: string,
 *  count: number
 * }} CountByHour
 *
 * @param {{
 *  start: string,
 *  end: string,
 *  channelId: string,
 *  type: string
 * }} param0
 *
 * @returns {{
 *  browsersCount: BrowsersStats,
 *  conversationCount: {(CountByHour | CountByDay)}[]
 *  userCount: {(CountByHour | CountByDay)}[]
 * }}
 */

export const handleFetchUsersStats = async ({
  start,
  end,
  channelId,
  type = 'hour',
}) => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/statistic/channel/users',
    params: {
      start,
      end,
      channelId,
      type,
    },
    withCredentials: true,
    headers: {
      'Conent-Type': 'application/json',
    },
  });
  return response.data;
};
